export default {
    // baseUrl: "https://kjlmqyapidev.unions88.com/api",
    baseUrl: "https://kjlm.unions9.com/api"
}


// WEBPACK FOOTER //
// ./src/seetings/index.js